import React from 'react';

import { Container, TabItem, TabContent, TabName } from './styles';

interface TabProps {
  title?: string;
  children?: React.ReactNode;
  count?: number;
  height?: string;
  id: number;
  checked: boolean;
  onChange: () => void;
}
export const Tab = ({
  title,
  children,
  count,
  height = '10',
  id,
  checked,
  onChange,
}: TabProps) => {
  return (
    <TabItem>
      <input
        type="radio"
        name="tabs"
        id={`tabs${id}`}
        checked={checked}
        onChange={onChange}
      />
      <TabName
        htmlFor={`tabs${id}`}
        role="tab"
        aria-selected="true"
        aria-controls={`panel${id}`}
        tabIndex={id}
      >
        {title}
        {typeof count === 'number' && (
          <span>
            <b>{count}</b>
          </span>
        )}
      </TabName>
      <TabContent
        height={height}
        id={`tab-content${id}`}
        role="tabpanel"
        aria-labelledby="description"
        aria-hidden="false"
      >
        {children}
      </TabContent>
    </TabItem>
  );
};

const Tabs = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Tabs;

// Tab.defaultProps = {
//   count: null,
//   height:10,
// };
